import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./assets/scss/styles.scss";
import Header from "./components/Header/Header";
import Error404 from "./components/Error404";

import logoUsados from "./assets/images/marcas/usados.png";
import logoFiat from "./assets/images/marcas/fiat.png";
import logoFord from "./assets/images/marcas/ford.png";
import logoJeep from "./assets/images/marcas/jeep.png";
import logoPeugeot from "./assets/images/marcas/peugeot.png";
import logoRentauto from "./assets/images/marcas/rentauto.png";
import logoQuicklane from "./assets/images/marcas/quicklane.png";
import { useEffect, useState } from "react";

function App() {
  return (
    <Router basename="/consultas-redes">
      <Switch>
        <Route exact path="/">
          <Header marca={"consultas"} />
        </Route>

        <Route path="*">
          <Header bg="bgDark" />
          <Error404 />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;

